import React from 'react';

interface LoadingBufferProps {
  isLoading: boolean;
  width?: number;
  height?: number;
}

const LoadingSpinner: React.FC<LoadingBufferProps> = ({ isLoading , width = 16, height= 16 }) => {
  const svgStyle: React.CSSProperties = {
    animation: isLoading ? 'rotate 2s linear infinite' : 'none',
    margin: '0px 2px -3px 5px',  
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={svgStyle}
      >
        <g clipPath="url(#clip0_2340_105539)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5332 0.933203V5.3332H7.46654V0.933203H8.5332Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.48894 6.24414L2.28894 3.04414L3.04414 2.28894L6.24414 5.48894L5.48894 6.24414Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.125s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7556 5.48894L12.9556 2.28894L13.7108 3.04414L10.9108 6.24414L9.7556 5.48894Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.25s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6676 7.4612L15.4665 7.46654L15.4644 8.5332L10.6644 8.5268L10.6676 7.4612Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.375s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.933203 7.4612H5.3332V8.52787H0.933203V7.4612Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.9s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.24414 10.9108L3.04414 13.7108L2.28894 12.9556L5.48894 9.7556L6.24414 10.9108Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.625s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9556 13.7108L9.7556 10.9108L10.9108 9.7556L13.7108 12.9556L12.9556 13.7108Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.75s' }}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5332 10.6665V15.4665H7.46654V10.6665H8.5332Z"
            fill="#73889C"
            style={{ animation: 'fade 0.9s ease-in-out infinite 0.975s' }}
          />
        </g>
        <defs>
          <clipPath id="clip0_2340_105539">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <style>
        {`
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
          @keyframes fade {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;